import React, {useState, useEffect} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {FunctionComponent} from "react"
import {CustomerBlockDto} from "../api/models"
import {number} from "prop-types"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import { useCustomer } from "../../../common/contexts/CustomerContext"

interface CategoryRowProps {
	cards: CustomerBlockDto[]
	levelId: number
	isGoalLevel: boolean
}

const CategoryRow: FunctionComponent<CategoryRowProps> = ({cards, isGoalLevel, levelId}) => {
	const navigate = useNavigate()
	let {customerId} = useParams()
	const {translations} = useUserPreferences()
	const {customer} = useCustomer()
	const populateClasses = (card: CustomerBlockDto) => {
		let baseClass = "category-card"

		if (card.RequirementStatus == 4) {
			baseClass += " category-card category-card--completed"
		}

		baseClass += ` category-card--cat${card.RequirementCategoryId}`
		// Append the level class, e.g. "level-1", "level-2", etc.
		baseClass += ` level-${card.RequirementStatus}`

		return baseClass
	}

	const customClasses = (): string => {
		let ctmClass = "category-row"
		if (isGoalLevel) ctmClass += " category-row--dashed"

		return ctmClass
	}

	if (!customerId)
		customerId = customer.Id

	const handleClick = (id: number) => {
		navigate(`/questionnaire/${customerId}/${id}`)
	}

	return (
		<div className={customClasses()}>
			{isGoalLevel && <div className='category-goal-text'>{translations.tmsGoal || "Goal"}</div>}
			<div
				className={`category-block`}
				style={
					{
						"--fill-percent": `${cards[0]?.progressPrecent}%`
					} as React.CSSProperties
				}
			>
				<div className={`fill-overlay fill-overlay--cat${cards[0]?.RequirementCategoryId ?? ""}`}></div>
				<div className='category-text'>
					<div className='category-name'>
						{translations.level || "Level"} {levelId}
					</div>
				</div>
			</div>
			<div className='category-card-wrapper'>
				{cards.map(card => (
					<div className={populateClasses(card)} onClick={() => handleClick(card.Id)} key={card.Id}>
						{card.Name}
						{/* Three small boxes */}
						<div className='level-boxes'>
							<div className='level-box'></div>
							<div className='level-box'></div>
							<div className='level-box'></div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default CategoryRow
